<script>
import { Bar, mixins } from 'vue-chartjs';
import chartjsPluginAnnotation from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
    name: 'SalaryIncomeBarChart',
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options', 'displayLegend'],
    computed: {
        inner_options() {
            const { options } = this;
            options.legend.display = this.display_legend;
            return options;
        },
    },
    watch: {
        display_legend() {
            this.renderChart(this.chartData, this.inner_options);
        },
    },
    mounted() {
        this.addPlugin(chartjsPluginAnnotation);
        this.addPlugin(ChartDataLabels);
        this.renderChart(this.chartData, this.inner_options);
    },
};
</script>
